
export const getRestIdFromGid = (gid) => {
    if(!gid) return;
    return gid.split("/")[gid.split("/").length - 1];
  }

  export const getGidFromRestId = (id, type) => {
    if(!id || !type) return;
    return `gid://shopify/${type}/${id}`
  }

  export const getFormatedPrice = (priceAmount, base = 100) => {
    if(!priceAmount) return;
    if(priceAmount % base > 0){
      return `$${(priceAmount / base).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
    }else{
      return `$${(priceAmount / base).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
    }
  }

  export const buildImageSrcSet = (base, sizes = [80, 96, 160, 192]) => {
    const sources = sizes.map((size) => {
        return `${base}&width=${size} ${size}w`;
    });
    return sources.join(",")
  }
